import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cards: {
    padding: 16,
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all ease 0.3s',
    '& .applicantName': {
      transition: 'all ease 0.3s',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '70vw',
    },
  },
  active: {
    background: theme.palette.primary.light,
    transition: 'all ease 0.3s',
    '& .applicantName': {
      transition: 'all ease 0.3s',
      color: theme.palette.primary.main,
    },
  },
  name: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
}))
